<template>
  <div>
    <div
      :class="$vuetify.breakpoint.mobile ? 'flex-column mb-5' : 'justify-space-between'"
      class="d-flex"
    >
      <div class="align-self-start titre-h3 mt-3 mb-3 ml-1">
        Mes apports
        <AgrButton
          class="margin-top"
          icon
          @click="isOpenModalHelp = true"
        >
          <v-icon color="primary">
            mdi-information
          </v-icon>
        </AgrButton>
      </div>
      <AdherentRebond
        v-if="redirection"
        :class="$vuetify.breakpoint.mobile ? '' :'position'"
        :path-origine="pagePath"
        :redirection="redirection"
      />
    </div>
    <div
      v-if="isBandeauGraineAffiche"
      :class="[$vuetify.breakpoint.mobile ? 'flex-column' : 'justify-space-between', !$vuetify.breakpoint.mobile && redirection ? 'mt-8' : '']"
      class="d-flex mb-3 ml-1"
    >
      <BaseSelectAnneeRecolte
        :annee-recolte-selected="anneeSelected"
        :code-graine-selected="codeGraineRs3Selected"
        :liste-annees-recoltes="listeAnneesRecoltes"
        :liste-graines-a-afficher="grainesContractualiseesEtRecoltees"
        @selectAnneeRecolte="selectRecolte"
        @selectGraine="selectGraine"
      />
      <div
        v-if="hasRecoltePourGraineSelectionnee"
        :class="$vuetify.breakpoint.mobile ? 'w-100 mt-3' : 'mr-1' "
        class="align-self-end"
      >
        <AgrButton
          block
          class="mb-3"
          elevation="0"
          large
          @click="onComparaisonQualites()"
        >
          <v-icon
            class="mr-4"
          >
            mdi-finance
          </v-icon>
          <span class="action white--text">Me comparer</span>
        </AgrButton>
        <v-btn
          block
          class="btn-secondaire mb-3"
          color="branche"
          elevation="0"
          rounded
          @click="isOpenModalFiltres = true"
        >
          <v-icon
            class="--text-branche mr-4"
            start
          >
            mdi-filter-variant
          </v-icon>
          <span class="action text- --text-branche">Filtrer mes apports</span>
        </v-btn>
      </div>
    </div>
    <BaseMessageServerError v-if="erreurInitialisation" />

    <div class="px-md-1 mt-3">
      <!-- Résumé de la récolte -->
      <BaseLoader v-if="loadingInitialisation" />
      <div v-if="!loadingInitialisation && !erreurInitialisation">
        <FiltreApportChips
          v-if="!loadingInitialisation"
          :filtres="filtresApportsActifs"
          class="my-5"
          @delete="onDeleteFiltreApport"
        />
        <ResumeDetailMensuel
          v-if="hasRecoltePourGraineSelectionnee"
          :graine-rs3="graineRs3Selected"
          :loading-synthese="loading.synthese"
          :nb-apports="nbApports"
          :has-reglement-campagne="hasReglementCampagne"
          :resume-graine-mois="recolteGraineMois.resume"
          :loading-reglement-campagne="loading.reglementCampagne"
          :tooltip-reglement-campagne="tooltipReglementCampagne"
          class="mt-5"
          @download-reglement-campagne="telechargerPDFReglementCampagne"
          @button="downloadPdfApport()"
        />

        <BaseCardV2
          v-if="!hasRecoltePourGraineSelectionnee && !loadingInitialisation && filtresApportsActifs.length === 0"
          class="mt-5"
        >
          <div
            :class="$vuetify.breakpoint.mobile ? 'mt-6' :'mt-10' "
            class="d-flex align-center flex-column pb-6"
          >
            <img
              alt="no-apport"
              src="@/assets/no-apport.svg"
            >
            <div
              :class="$vuetify.breakpoint.mobile ? 'mb-6' :'mx-16' "
              class=" d-flex flex-column intro texte-gris-fonce text-align-center mt-2 text-justify mx-5"
            >
              <span class="text-center">Nous ne disposons pas d'apport pour cette graine et cette année de
                récolte.</span>
              <span class="mt-1 text-center">Rendez-vous dans votre dépôt pour réaliser une livraison.</span>
              <span class="mt-1 text-center">Vous retrouverez ensuite les détails de chaque apport (dates, poids,
                qualités, lieu de livraison).</span>
            </div>
          </div>
        </BaseCardV2>
        <BaseCardV2
          v-if="!loadingInitialisation && !hasRecoltePourGraineSelectionnee && filtresApportsActifs.length"
          class="mt-5"
        >
          <div
            :class="$vuetify.breakpoint.mobile ? 'mt-6' : 'mt-10'"
            class="d-flex
        align-center
        flex-column pb-6"
          >
            <img
              alt="no-apport"
              src="@/assets/no-apport.svg"
            >
            <div
              :class="$vuetify.breakpoint.mobile ? 'mb-6' : 'mx-16' "
              class=" d-flex flex-column intro texte-gris-fonce  mt-2 text-justify mx-5"
            >
              <span class="text-center titre-h4 secondary--text">Aucun apport ne correspond à ces filtres.</span>
              <span class="mt-1 mb-5 mt-5 text-center">Merci de revoir vos filtres.</span>
            </div>
          </div>
        </BaseCardV2>
        <BaseMessage
          v-if="!loadingInitialisation && errorMessageEdition"
          :message="errorMessageEdition"
          type="error"
        />
        <v-list class="py-0">
          <v-list-item
            v-for="(recolteMois, indexMois) in recoltesMoisAvecApportsTries"
            :key="indexMois"
            class="px-0"
            dense
          >
            <v-list-item-content class="list-item-contour py-0">
              <div
                :class="[indexMois === 0 ? 'mt-4' : '', $vuetify.breakpoint.mobile ? 'mx-0' : 'mx-5']"
                class=" d-flex flex-column intro texte-gris-fonce align-center mb-4 text-justify"
              >
                <span>
                  {{ recolteMois.mois | date('MMMM yyy') }}
                </span>
              </div>
              <!-- liste des livraisons -->
              <template>
                <v-card
                  v-for="(recolteJour, indexJour) in recoltesJoursDuMoisAvecApportsTries(recolteMois)"
                  :key="indexJour"
                  :class="[recolteMois.recoltesJour.length > 0 ? 'mb-6' : '', !$vuetify.breakpoint.mobile ? 'pa-4' : '']"
                >
                  <div
                    class="justify-center is-active"
                    @click="onClicChevron(recolteJour.jour)"
                  >
                    <v-row>
                      <v-col
                        cols="6"
                        md="2"
                        sm="6"
                      >
                        <div class="text-md-left ml-3">
                          <span class="titre-h3 secondary--text"> {{ recolteJour.apports[0].dateApport | date('EEEE dd')
                          }}</span>
                        </div>
                      </v-col>
                      <v-col
                        v-if="$vuetify.breakpoint.mobile"
                        class="align-right pr-6"
                        cols="6"
                        md="2"
                        sm="6"
                      >
                        <v-icon
                          color="grey-dark"
                        >
                          {{ displayLignesApport[findIndexJour(recolteJour.jour)].display ? 'mdi-chevron-up' :
                            'mdi-chevron-down' }}
                        </v-icon>
                      </v-col>
                      <v-col
                        cols="5"
                        md="2"
                        sm="5"
                      >
                        <BaseDataV2
                          :style-entete="false"
                          :value="recolteJour.resume.cumulPoidsNetEnKg | roundNumber(3, 0.001)"
                          custom-class="titre-h4 secondary--text"
                          label="Poids net"
                          message="Aucune donnée"
                          unit="t"
                        />
                      </v-col>
                      <v-col
                        cols="6"
                        md="3"
                        sm="6"
                      >
                        <BaseDataV2
                          :style-entete="false"
                          :value="recolteJour.resume.cumulPoidsAuxNormesEnKg | roundNumber(3, 0.001)"
                          custom-class="titre-h4 secondary--text"
                          label="Poids aux normes"
                          message="Aucune donnée"
                          unit="t"
                        />
                      </v-col>
                      <v-col
                        v-if="!$vuetify.breakpoint.mobile"
                        class="align-right pr-10"
                        cols="12"
                        md="5"
                        sm="12"
                      >
                        <v-icon
                          color="grey-dark"
                          large
                        >
                          {{ displayLignesApport[findIndexJour(recolteJour.jour)].display ? 'mdi-chevron-up' :
                            'mdi-chevron-down' }}
                        </v-icon>
                      </v-col>
                    </v-row>
                  </div>

                  <!-- lignes -->
                  <div v-if="displayLignesApport[findIndexJour(recolteJour.jour)].display">
                    <v-list class="pb-0">
                      <v-list-item
                        v-for="(apport, indexApport) in recolteJour.apports"
                        :key="indexApport"
                        dense
                      >
                        <v-list-item-content v-if="!$vuetify.breakpoint.mobile">
                          <DetailApportHeader
                            v-if="indexApport === 0"
                            :apports="recolteJour.apports"
                            :graine-rs3="graineRs3Selected"
                            class="mb-5"
                          />
                          <v-divider
                            v-if="indexApport > 0"
                            :key="indexApport"
                            class="mb-5"
                          />
                          <DetailApport
                            :affichage-entete="indexApport === 0"
                            :apport="apport"
                            :apports="recolteJour.apports"
                            :graine-rs3="graineRs3Selected"
                          />
                        </v-list-item-content>
                        <v-list-item-content v-else>
                          <v-divider
                            v-show="indexApport > 0"
                            :key="indexApport"
                            class="mt-0 mb-5"
                          />
                          <DetailApportMobile
                            :apport="apport"
                            :graine-rs3="graineRs3Selected"
                          />
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </div>
                </v-card>
              </template>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>
    </div>
    <HelpModal
      v-if="isOpenModalHelp"
      titre="mes apports"
      :is-open-modal-help="isOpenModalHelp"
      @close="isOpenModalHelp = false"
    >
      <div slot="baseCardHelpContent">
        <div class="texte text-justify texte-gris-fonce pa-8">
          <p>Cette page vous affiche le détail des apports à votre coopérative, pour la graine sélectionnée.</p>
          <p>Une synthèse vous expose les cumuls de tonnages et vos analyses moyennes pondérées.</p>
          <p>
            Vous retrouvez ensuite un cumul par jour des quantités, puis le détail par bon d'apport du jour
            considéré.
          </p>

          <p>Les analyses sont susceptibles d’être réalisées en décalage.</p>
          <p>"?" s’affiche dans ce cas tant que les analyses ne sont pas disponibles.</p>
          <p>Les valeurs prises en compte dans les moyennes sont celles mesurées à la livraison de marchandise.</p>
        </div>
      </div>
    </HelpModal>
    <ComparaisonApportsModal 
      v-if="isOpenModalComparaison"
      :titre="titreFormatted(graineRs3Selected ? graineRs3Selected.libelle : null)"
      :is-open-modal-comparaison="isOpenModalComparaison"
      @close="isOpenModalComparaison = false"
    />
    <InfoModal
      v-if="isOpenModaleInfosManquantes"
      confirm-text="Renseigner les infos"
      titre="Infos manquantes"
      :is-open-modale-infos-manquantes="isOpenModaleInfosManquantes"
      @close="isOpenModaleInfosManquantes = false"
      @confirm="toCompte()"
    >
      <InfoManquanteContentModal />
    </InfoModal>
    <FiltreApportsModal
      v-if="isOpenModalFiltres"
      :annee-recolte="anneeSelected"
      :code-graine-rs3="codeGraineRs3Selected"
      :is-open-modal-filtres="isOpenModalFiltres"
      @close="isOpenModalFiltres = false"
      @update="onUpdateFiltres()"
    />
  </div>
</template>

<script>
import AdherentRebond from '@/views/admin/rebond/components/adherent-rebond.vue'
import BaseMessageServerError from '@/components/common/base-message-server-error.vue'
import BaseCardV2 from '@/components/card/base-card-v2.vue'
import ResumeDetailMensuel from './components/resume-detail-mensuel.vue'
import DetailApport from './components/detail-apport.vue'
import DetailApportHeader from './components/detail-apport-header.vue'
import DetailApportMobile from './components/detail-apport-mobile.vue'
import {mapActions, mapGetters} from 'vuex'
import {format} from 'date-fns'
import BaseSelectAnneeRecolte from '@/components/common/base-select-annee-recolte.vue'
import {orderBy} from 'lodash'
import {clone} from '@/utils/clone'
import {AgrButton} from '@agrial/ui'
import BaseDataV2 from '@/components/common/base-data-v2.vue'
import BaseMessage from '@/components/common/base-message.vue'
import BaseLoader from '@/components/common/base-loader.vue'
import InfoModal from '@/components/modal/info-modal.vue'
import InfoManquanteContentModal from '@/components/modal/info-manquante-content-modal.vue'
import FiltreApportsModal from '@/views/detail-recolte/components/modal/filtre-apports-modal.vue'
import FiltreApportChips from '@/views/detail-recolte/components/chip/filtre-apport-chips.vue'
import locale from 'date-fns/locale/fr'
import HelpModal from '@/components/modal/help-modal.vue'
import capitalize from '@/filters/string.filter'
import ComparaisonApportsModal from './components/modal/comparaison-apports-modal.vue'

export default {
  name: 'DetailRecolte',
  components: { AgrButton, AdherentRebond, ComparaisonApportsModal, HelpModal, BaseCardV2, BaseDataV2, BaseMessage, BaseSelectAnneeRecolte, BaseLoader, InfoModal, InfoManquanteContentModal, ResumeDetailMensuel, BaseMessageServerError, DetailApport, DetailApportHeader, DetailApportMobile, FiltreApportsModal, FiltreApportChips },
  data () {
    return {
      pagePath: 'main.mes-recoltes',
      loading: {
        grainesRs3: true,
        recolte: true,
        filtres: false,
        filtresApports: false,
        updateFiltres: false,
        reglementCampagne: false,
        synthese: false
      },
      erreur: {
        grainesRs3: false,
        recolte: false,
        filtres: false,
        filtresApports: false,
        updateFiltres: false,
        reglementCampagne: false
      },
      anneeSelected: null,
      codeGraineRs3Selected: null,
      isOpenModalHelp: false,
      isOpenModalComparaison: false,
      isOpenModaleInfosManquantes: false,
      errorMessageEdition: null,
      tooltipReglementCampagne: null,
      hasReglementCampagne: false,
      listeGrainesAAfficher: null,
      displayLignesApport: [],
      isOpenModalFiltres: false
    }
  },

  computed: {
    ...mapGetters({
      adherent: 'adherent/adherent',
      grainesContractualiseesEtRecoltees: 'graine/grainesContractualiseesEtRecoltees',
      anneeRecolteEnCours: 'application/anneeRecolteEnCours',
      anneeRecolteActive: 'application/anneeRecolteActive',
      codeGraineActive: 'application/codeGraineActive',
      recolte: 'recolte/recolte',
      listeAnneesRecoltes: 'recolte/listeAnneesRecoltes',
      filtresApport: 'filtresApports/filtresAdherent',
      reglementCampagne: 'reglementCampagne/reglementCampagne',
      filtresApportValeursPossible: 'filtresApports/filtresValeursPossibles',
      pdfReglementCampagne:  'reglementCampagne/pdfReglementCampagne',
      isParametresExploitationComplet: 'parametresExploitation/isParametresExploitationComplet',
      redirection: 'redirection/redirection'
    }),

    graineRs3Selected () {
      return this.grainesContractualiseesEtRecoltees.find(graine => graine.code === this.codeGraineRs3Selected)
    },
    detailsRecolteGraine () {
      // graineRs3Selected provient d'un .find() : il peut etre absent.
      return this.recolte.recoltesGraine.find(r => r.codeIdaRs3 === this.graineRs3Selected?.code)
    },
    recolteGraineMois () {
      let result
      if (this.hasRecoltePourGraineSelectionnee && this.detailsRecolteGraine) {
        result = {
          resume: this.detailsRecolteGraine?.resume,
          recoltesJour: []
        }
        // on met à plat tous les mois
        this.detailsRecolteGraine?.recoltesMois?.forEach(rm => rm.recoltesJour?.forEach(rj => result.recoltesJour.push(rj)))
      }
      return result
    },
    nbApports () {
      const result = (this.hasRecoltePourGraineSelectionnee && this.recoltesJoursAvecApportsTries && this.recoltesJoursAvecApportsTries.length > 0) ? this.recoltesJoursAvecApportsTries
        .flatMap(a => a.apports.length)
        .reduce((a, b) => a + b) : null
      return result != null ? result : null
    },
    /**
     * @return liste de recolteJours avec apports ordonnés .
     */
    recoltesJoursAvecApportsTries () {
      if (this.hasRecoltePourGraineSelectionnee && this.recolteGraineMois) {
        let recoltesJour = clone(this.recolteGraineMois.recoltesJour)
        return recoltesJour.sort().reverse()
          .map((rj) => {
            rj.apports = orderBy(rj.apports, ['dateApport','poidsNetEnKg'], ['desc','desc'])
            return rj
          })
      }
      return null
    },
    recoltesMoisAvecApportsTries () {
      if (this.detailsRecolteGraine && this.detailsRecolteGraine.recoltesMois && this.detailsRecolteGraine.recoltesMois.length > 0) {
        let recoltesMois = clone(this.detailsRecolteGraine.recoltesMois)
        return recoltesMois.sort().reverse()
         .map((rm) => {
            rm.apports = orderBy(rm.apports, ['dateApport', 'poidsNetEnKg'], ['desc', 'desc'])
            return rm
          })
      }
      return null
    },
    hasRecoltePourGraineSelectionnee () {
      return !this.loading.recolte && !!this.graineRs3Selected && !!this.graineRs3Selected.code && Object.keys(this.recolte).length && !!this.detailsRecolteGraine
    },
    erreurInitialisation () {
      return this.erreur.recolte || this.erreur.grainesRs3
    },
    loadingInitialisation () {
      return this.loading.recolte || this.loading.grainesRs3 || this.loading.filtresApports
    },
    isBandeauGraineAffiche () {
      return this.listeGrainesAAfficher && this.listeGrainesAAfficher.length
    },
    filtresApportsActifs () {
      let filtresChips = []
      if (this.filtresApport.numerosBonsApport != null && this.filtresApport.numerosBonsApport !== 'Tous') {
        filtresChips.push({
          type: 'numerosBonsApport',
          libelle: 'Bon n° ' + this.filtresApport.numerosBonsApport
        })
      }
      if ( this.filtresApport.typesContratApport!= null && this.filtresApport.typesContratApport !== 'Tous') {
        filtresChips.push({
          type: 'typesContratApport',
          libelle: this.filtresApport.typesContratApport
        })
      }
      if (this.filtresApport.numerosContratsApport != null & this.filtresApport.numerosContratsApport !== 'Tous') {
        filtresChips.push({
          type: 'numerosContratsApport',
          libelle: (this.filtresApport.numerosContratsApport !== 'Sans contrat' ? 'Contrat n° ' : '') + this.filtresApport.numerosContratsApport
        })
      }
      if (this.filtresApport.moisApport!= null && this.filtresApport.moisApport !== 'Tous' && this.filtresApport.moisApport !== '0') {
        const mois = [
          'Janvier',
          'Février',
          'Mars',
          'Avril',
          'Mai',
          'Juin',
          'Juillet',
          'Août',
          'Septembre',
          'Octobre',
          'Novembre',
          'Décembre'
        ]
        filtresChips.push({
          type: 'moisApport',
          libelle: mois[(this.filtresApport.moisApport - 1)]
        })
      }
      if (this.filtresApport.grainesValorisees!= null && this.filtresApport.grainesValorisees !== 'Tous' && this.filtresApport.grainesValorisees.codeGraineValorisee !== 'Tous') {
        filtresChips.push({
          type: 'grainesValorisees',
          libelle: this.filtresApport.grainesValorisees.libelleGraineValorisee
        })
      }
      return filtresChips
    }
  },

  created () {
    this.getRedirection(this.pagePath)
    const numtiersSelected = this.$cookies.get('NUMTIERS_SELECTED') || null
    this.getParametresExploitationComplet()
    this.fetchRecoltesContractualiseesEtRecoltees(numtiersSelected)
    this.anneeSelected = this.anneeRecolteActive != null ? this.anneeRecolteActive : this.anneeRecolteEnCours
    if (numtiersSelected != null) {
      this.fetchAdherent(numtiersSelected)
        .then(() => {
          this.loadFiltres()
          this.loadGrainesRs3()
        })
    } else {
      this.loadFiltres()
      this.loadGrainesRs3()
    }
  },

  methods: {
    ...mapActions({
      updateAnneeRecolteActive: 'application/updateAnneeRecolteActive',
      updateCodeGraineActive: 'application/updateCodeGraineActive',
      fetchAdherent: 'adherent/fetchAdherent',
      fetchRecoltesContractualiseesEtRecoltees: 'recolte/fetchRecoltesContractualiseesEtRecoltees',
      getGrainesContractualiseesEtRecoltees: 'graine/getGrainesContractualiseesEtRecoltees',
      fetchRecolteByAnnee: 'recolte/fetchRecolteByAnnee',
      getPdfApport: 'recolte/getPdfApport',
      initFiltres: 'filtresComparaison/initFiltres',
      initFiltresApports: 'filtresApports/initFiltresApports',
      getReglementCampagne: 'reglementCampagne/getReglementCampagne',
      setFiltres: 'filtresComparaison/setFiltres',
      setFiltresApport: 'filtresApports/setFiltres',
      telechargerDocumentPdf: 'reglementCampagne/telechargerDocumentPdf',
      getParametresExploitationComplet: 'parametresExploitation/getParametresExploitationComplet',
      getRedirection: 'redirection/getRedirection',
    }),

    loadGrainesRs3 () {
      this.loading.grainesRs3 = true
      this.erreur.grainesRs3 = false

      this.getGrainesContractualiseesEtRecoltees(this.anneeSelected)
        .then(() => {
          if (this.grainesContractualiseesEtRecoltees.length) {
            if (this.codeGraineActive != null) {
              const indexGrainePrecedente = this.grainesContractualiseesEtRecoltees.findIndex(graine => graine.code === this.codeGraineActive)
              if (indexGrainePrecedente === -1) {
                //graine plus présente sur l'année en court
                this.codeGraineRs3Selected = this.grainesContractualiseesEtRecoltees[0].code
              } else {
                this.codeGraineRs3Selected = this.codeGraineActive
              }
            } else {
              this.codeGraineRs3Selected = this.grainesContractualiseesEtRecoltees[0].code
            }
            this.listeGrainesAAfficher = this.grainesContractualiseesEtRecoltees
            this.loadFiltresApports()
          } else {
            this.listeGrainesAAfficher = []
            this.codeGraineRs3Selected = null
            this.loading.recolte = false
          }
          this.updateCodeGraineActive(this.codeGraineRs3Selected)
          this.$cookies.set('LAST_CONSULTATION_DETAIL_RECOLTE_' + this.codeGraineRs3Selected, format(new Date(Date.now()), 'dd/MM/yyyy HH:mm', { locale }))
        })
        .catch(() => {
          this.erreur.grainesRs3 = true
        })
        .finally(() => {
          this.loading.grainesRs3 = false
        })
    },
    loadRecoltes () {
      this.loading.recolte = true
      this.erreur.recolte = false

      const params = {
        anneeRecolte: this.anneeSelected,
        filtreNumeroBonApport: this.filtresApport ? this.filtresApport.numerosBonsApport : null,
        filtreTypeContratApport: this.filtresApport ? this.filtresApport.typesContratApport : null,
        filtreNumeroContratApport: this.filtresApport && this.filtresApport.numerosContratsApport ? this.filtresApport.numerosContratsApport  : 'Tous',
        filtreMoisApport: this.filtresApport ? this.filtresApport.moisApport : null,
        filtreGraineValoriseeApport: this.filtresApport ? this.filtresApport.grainesValorisees : null
      }

      this.fetchRecolteByAnnee(params)
        .catch(() => {
          this.erreur.recolte = true
        })
        .finally(() => {
          this.loading.recolte = false
          this.loadReglementCampagne()
          this.initDisplayLignesApport()
        })
    },    
    loadFiltres () {
      this.loading.filtres = true
      this.erreur.filtres = false

      return this.initFiltres(this.adherent.codeRegion)
        .catch(() => {
          this.erreur.filtres = true
        })
        .finally(() => {
          this.loading.filtres = false
        })
    },
    loadFiltresApports () {
      this.loading.filtresApports = true
      this.erreur.filtresApports = false
      const params = {
        codeGraineRs3: this.codeGraineRs3Selected,
        anneeRecolte: this.anneeSelected
      }
      this.initFiltresApports(params)
        .then(() => {
          const valeursParDefautFiltresApport = {
            numerosBonsApport: this.$route.params.numeroApport ? this.$route.params.numeroApport : this.filtresApportValeursPossible.numerosBonsApport.length ? this.filtresApportValeursPossible.numerosBonsApport[0] : null,
            typesContratApport: this.filtresApportValeursPossible.typesContratApport.length ? this.filtresApportValeursPossible.typesContratApport[0] : null,
            numerosContratsApport: this.filtresApport && this.filtresApport.numerosContratsApport && this.filtresApport.numerosContratsApport !== 'Tous' ? this.filtresApport.numerosContratsApport : this.$route.params.numeroContrat ? this.$route.params.numeroContrat : this.filtresApportValeursPossible.numerosContratsApport.length ? this.filtresApportValeursPossible.numerosContratsApport[0] : null,
            moisApport: this.filtresApportValeursPossible.moisApport.length ? Object.values(this.filtresApportValeursPossible.moisApport[0])[0] : null,
            grainesValorisees: this.filtresApportValeursPossible.grainesValorisees.length && this.filtresApportValeursPossible.grainesValorisees[0]!= null ? this.filtresApportValeursPossible.grainesValorisees[0] : null
          }
          this.setFiltresApport(valeursParDefautFiltresApport).then(() => {
             this.loadRecoltes()
          })
        })
        .catch(() => {
          this.erreur.filtresApports = true
        })
        .finally(() => {
          this.loading.filtresApports = false
        })
    },
    selectRecolte (anneeRecolte) {
      this.anneeSelected = anneeRecolte
      this.updateAnneeRecolteActive(anneeRecolte)
      this.reloadCultures()
      this.$route.params.numeroContrat = null
      this.$route.params.numeroApport = null
      this.loadGrainesRs3()
    },
    selectGraine (codeGraine) {
      this.codeGraineRs3Selected = codeGraine
      this.updateCodeGraineActive(codeGraine)
      this.$route.params.numeroContrat = null
      this.$route.params.numeroApport = null
      this.loadFiltresApports()
      this.initDisplayLignesApport()
      this.loadReglementCampagne()
    },
    reloadCultures () {
      this.loading.cultures = true
      this.getGrainesContractualiseesEtRecoltees(this.anneeRecolteActive)
        .then(() => {
          if (this.grainesContractualiseesEtRecoltees.filter(g => g.code === this.codeGraineActive).length === 0) {
            this.updateCodeGraineActive(this.grainesContractualiseesEtRecoltees[0].code)
          }
        })
        .finally(() => {
          this.loading.cultures = false
        })
    },
    downloadPdfApport () {
      this.errorMessageEdition = null
      this.loading.synthese = true
      let data = {}
      data.graineRs3 = this.graineRs3Selected.code
      data.moisDebut = format(new Date(this.anneeSelected, '06'), 'yyyy-MM', { locale })
      data.moisFin = format(new Date(new Date().getFullYear(), '05'), 'yyyy-MM', { locale })

      this.getPdfApport(data)
        .then(blobResponse => {
          const url = window.URL.createObjectURL(new Blob([blobResponse]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'apport.pdf')
          document.body.appendChild(link)
          link.click()
        }).catch(() => {
          this.errorMessageEdition = 'Erreur lors de l\'appel du pdf'
        })
        .finally(() => {
          this.loading.synthese = false
        })
    },
    loadReglementCampagne () {
      this.loading.reglementCampagne = true
      this.erreur.reglementCampagne = false

      this.getReglementCampagne({anneeRecolte: this.anneeSelected, codeGraineRs3: this.codeGraineRs3Selected})
        .then(() => {
          this.hasReglementCampagne = !!(this.reglementCampagne && Object.entries(this.reglementCampagne).length > 0)
          this.tooltipReglementCampagne = 'Consultation du document de règlement de campagne'
        })
        .catch(() => {
          this.tooltipReglementCampagne = 'Nous ne parvenons pas à trouver votre document de règlement de campagne.'
          this.hasReglementCampagne = false
          this.erreur.reglementCampagne = true
        })
        .finally(() => this.loading.reglementCampagne = false)
    },
    telechargerPDFReglementCampagne () {
      this.loading.reglementCampagne = true
      this.erreur.reglementCampagne = false

      this.telechargerDocumentPdf(this.reglementCampagne)
        .then(() => {
          const popup = window.open('about:blank', '_blank')
          popup.location = window.URL.createObjectURL(new Blob([this.pdfReglementCampagne], {type: 'application/pdf'}))
        })
        .catch(() => {
          this.erreur.reglementCampagne = true
          this.tooltipReglementCampagne = 'Impossible de récupérer le pdf de règlement de campagne'
          this.hasReglementCampagne = false
        })
        .finally(() => this.loading.reglementCampagne = false)
    },
    /**
     * @return liste de recolteJours avec apports ordonnés .
     */
    recoltesJoursDuMoisAvecApportsTries (recolteMois) {
      if (this.hasRecoltePourGraineSelectionnee && recolteMois) {
        let recoltesJour = clone(recolteMois.recoltesJour)
        return recoltesJour.sort().reverse()
          .map((rj) => {
            rj.apports = orderBy(rj.apports, ['dateApport', 'poidsNetEnKg'], ['desc', 'desc'])
            return rj
          })
      }
      return null
    },
    initDisplayLignesApport () {
      if (this.hasRecoltePourGraineSelectionnee) {
        this.recoltesMoisAvecApportsTries.forEach(r => {
          r.recoltesJour.forEach((rj => {
            this.displayLignesApport.push({
              jour: rj.jour,
              display: false
            })
          }))
        })
      }
      return this.displayLignesApport
    },
    onClicChevron (jour) {
      if (this.displayLignesApport.length) {
        const indexJour = Object.values(this.displayLignesApport).findIndex(j => j.jour === jour)
        if (!this.displayLignesApport[indexJour].display) {
          // le jour sur lequel on a cliqué va passer de display = false à display = true => recherche si il y un autre jour d'ouvert pour le fermer
          const indexJourDisplayTrue = Object.values(this.displayLignesApport).findIndex(j => j.display === true)
          if (indexJourDisplayTrue !== -1) {
            this.displayLignesApport.splice(indexJourDisplayTrue, 1, { jour: this.displayLignesApport[indexJourDisplayTrue].jour, display: !this.displayLignesApport[indexJourDisplayTrue].display })
          }
        }
        this.displayLignesApport.splice(indexJour, 1, { jour: this.displayLignesApport[indexJour].jour, display: !this.displayLignesApport[indexJour].display })
      }
    },
    findIndexJour (jour) {
      return this.displayLignesApport.length ? Object.values(this.displayLignesApport).findIndex(j => j.jour === jour) : null
    },
    onComparaisonQualites () {
      if (this.isParametresExploitationComplet) {
        this.isOpenModalComparaison = true
      } else {
        this.isOpenModaleInfosManquantes = true
      }
    },
    titreFormatted (texte) {
      return texte ? capitalize.capitalize(texte) : ''
    },
    toCompte () {
      this.isOpenModaleInfosManquantes = false
      this.$router.push({ name: 'main.compte' })
    },
    onUpdateFiltres () {
      this.isOpenModalFiltres = false
      this.loadRecoltes()
    },
    onDeleteFiltreApport (filtreASupprimer) {
      const filtresApport = clone(this.filtresApport)
      filtresApport[filtreASupprimer.type] = 'Tous'
      this.setFiltresApport(filtresApport)
      this.loadRecoltes()
    }
  }
}
</script>

<style lang="scss" scoped>
.background {
  background: var(--gris);
}
.v-list-item__title:hover {
  color: #ffd54f !important;
}

.list-item-contour {
  background-color: #F1F2F5;
}

.v-divider {
  flex: 1 0 100% !important;
}
.detail-apport-header {
  background-color:#F1F2F5;
  padding: 4px;
  border: 1px;
  border-radius: 8px;
}
.align-right {
  text-align: end;
}
.align-left {
  text-align: start;
}
.is-active:hover {
  background-color: #F1F2F5;
  cursor: pointer;
}
.position {
  position: absolute;
  top: 0;
  right: 8px;
}
</style>
